import React from 'react';

import { ChevronIcon } from '@/assets/icons/chevron';
import { ChevronFullIcon } from '@/assets/icons/chevron-full';
import { DeleteXIcon } from '@/assets/icons/delete-x';
import DeleteXDesktopBoldIcon from '@/assets/icons/delete-x-desktop-bold';
import color from '@/core/features/styles/color';
import { bemModule } from '@/core/utils/bem-classname';

import styles from './chip.module.scss';

export type ChipSize = 'L' | 'S' | 'XL' | 'XXL' | 'normal';

export type ChipProps = React.PropsWithChildren<{
    active?: boolean;
    closeButtonSize?: number;
    closeable?: boolean;
    disabled?: boolean;
    extendable?: boolean;
    largeIcons?: boolean;
    loading?: boolean;
    onClick: () => void;
    onDeselect?: () => void;
    qaId?: string;
    rounded?: boolean;
    shadow?: boolean;
    size?: ChipSize;
}>;

const bem = bemModule(styles);

export default function Chip(props: ChipProps) {
    const {
        active,
        children,
        closeButtonSize = 12,
        closeable,
        disabled,
        extendable,
        largeIcons,
        loading,
        onClick,
        onDeselect,
        qaId,
        rounded,
        shadow,
        size = 'normal',
    } = props;

    return (
        <div
            className={`flex-center ${bem(styles.chip, { active, disabled, loading, rounded, shadow, [size]: true })}`}
            data-qa-id={qaId}
        >
            <div className={styles.content}>
                <span
                    className={styles.text}
                    onClick={onClick}
                >
                    {children}
                </span>
                {closeable &&
                    onDeselect &&
                    (largeIcons ? (
                        <DeleteXDesktopBoldIcon
                            className={bem(styles.icon, { largeCloseIcon: closeable })}
                            color={color('endeavour')}
                            height={closeButtonSize}
                            onClick={onDeselect}
                            width={closeButtonSize}
                        />
                    ) : (
                        <DeleteXIcon
                            className={bem(styles.icon, { closeIcon: closeable })}
                            color={color('endeavour')}
                            height={6}
                            onClick={onDeselect}
                            width={6}
                        />
                    ))}
                {extendable &&
                    (largeIcons ? (
                        <ChevronIcon
                            className={bem(styles.icon, { largeChevronIcon: extendable })}
                            color={color('endeavour')}
                            height={9}
                            onClick={onClick}
                            width={15}
                        />
                    ) : (
                        <ChevronFullIcon
                            className={bem(styles.icon, { chevronIcon: extendable })}
                            color={color('black')}
                            height={10}
                            onClick={onClick}
                            width={7}
                        />
                    ))}
            </div>
        </div>
    );
}
